import React from 'react';
import Button from '../Button/Button';
import './SelectedItemsBanner.css';

interface SelectedItemsBannerProps {
    selectedItemType: string;
    selectedItemsCount: number;
    clearSelectedItems: () => void;
    setShowAssignPartner: React.Dispatch<React.SetStateAction<boolean>>;
}

const SelectedItemsBanner: React.FC<SelectedItemsBannerProps> = ({ selectedItemType, selectedItemsCount, clearSelectedItems, setShowAssignPartner }) => {
    return (
            <div className="d-flex justify-content-center itemsSelected">
                <div style={{ width: '70%' }} className="d-flex">
                    <div style={{ width: '30%' }} className="d-flex align-items-center">
                        <span className="fw-bold">{selectedItemsCount} {selectedItemType} selected</span>
                    </div>
                    <div style={{ width: '70%' }} className="d-flex align-items-center justify-content-end">
                        <Button
                            backgroundColor="none"
                            color="#A8927D"
                            testId="close"
                            onClick={clearSelectedItems}
                            text="Cancel"
                            width="141px"
                            height="48px"
                            borderRadius="24px"
                            borderColor="#D0D0D0"
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button
                            backgroundColor="#A8927D29"
                            color="#A8927D"
                            text="Assign to Partner"
                            borderColor="#fff"
                            fontSize="12px"
                            width="160px"
                            fontWeight="600"
                            disable={false}
                            onClick={() => { setShowAssignPartner(true); }}
                        />
                    </div>
                </div>
            </div>
    );
}

export default SelectedItemsBanner;